// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-chatbot-kit-chat-container {
  position: relative;
  width: 275px;
}

.react-chatbot-kit-chat-inner-container {
  height: 500px;
  background-color: #fff;
  border-radius: 3px;
  border-radius: 5px;
}

.react-chatbot-kit-chat-header {
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  background-color: #efefef;
  font-family: Arial;
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  color: #514f4f;
  padding: 12.5px;
  font-weight: bold;
}

.react-chatbot-kit-chat-input-container {
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
}

.attribution + .react-chatbot-kit-chat-message-container {
  max-height: calc(100% - 105px);
}

.attribution
  + .react-chatbot-kit-chat-message-container
  + .react-chatbot-kit-chat-input-container {
  bottom: 1.55rem;
}

.react-chatbot-kit-chat-message-container {
  padding: 0 17.5px 10px 17.5px;
  overflow: scroll;
  height: 424px;
}

.react-chatbot-kit-chat-input {
  width: 100%;
  padding: 12.5px;
  border: none;
  font-size: 0.85rem;
  border-top: 1px solid #d8d8d8;
}

.react-chatbot-kit-chat-input-form {
  width: 100%;
  display: flex;
}

.react-chatbot-kit-chat-input::placeholder {
  color: #585858;
}

.react-chatbot-kit-chat-btn-send {
  background-color: #2898ec;
  width: 100px;
  border: none;
  color: #fff;
}

.react-chatbot-kit-chat-btn-send-icon {
  fill: #fff;
  width: 15px;
  margin: 0 auto;
}
`, "",{"version":3,"sources":["webpack://./src/react-chatbot-kit/components/Chat/Chat.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;AAChB","sourcesContent":[".react-chatbot-kit-chat-container {\n  position: relative;\n  width: 275px;\n}\n\n.react-chatbot-kit-chat-inner-container {\n  height: 500px;\n  background-color: #fff;\n  border-radius: 3px;\n  border-radius: 5px;\n}\n\n.react-chatbot-kit-chat-header {\n  border-top-right-radius: 5px;\n  border-top-left-radius: 5px;\n  background-color: #efefef;\n  font-family: Arial;\n  display: flex;\n  align-items: center;\n  font-size: 0.85rem;\n  color: #514f4f;\n  padding: 12.5px;\n  font-weight: bold;\n}\n\n.react-chatbot-kit-chat-input-container {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  display: flex;\n}\n\n.attribution + .react-chatbot-kit-chat-message-container {\n  max-height: calc(100% - 105px);\n}\n\n.attribution\n  + .react-chatbot-kit-chat-message-container\n  + .react-chatbot-kit-chat-input-container {\n  bottom: 1.55rem;\n}\n\n.react-chatbot-kit-chat-message-container {\n  padding: 0 17.5px 10px 17.5px;\n  overflow: scroll;\n  height: 424px;\n}\n\n.react-chatbot-kit-chat-input {\n  width: 100%;\n  padding: 12.5px;\n  border: none;\n  font-size: 0.85rem;\n  border-top: 1px solid #d8d8d8;\n}\n\n.react-chatbot-kit-chat-input-form {\n  width: 100%;\n  display: flex;\n}\n\n.react-chatbot-kit-chat-input::placeholder {\n  color: #585858;\n}\n\n.react-chatbot-kit-chat-btn-send {\n  background-color: #2898ec;\n  width: 100px;\n  border: none;\n  color: #fff;\n}\n\n.react-chatbot-kit-chat-btn-send-icon {\n  fill: #fff;\n  width: 15px;\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
